import * as types from "./types";

export const setCurrentSectionIndex = index => {
  return {
    type: types.SET_CURRENT_SECTION_INDEX,
    payload: index,
  };
};

export const adjustDrilledDownCountBy = count => {
  return {
    type: types.ADJUST_DRILLED_DOWN_COUNT_BY,
    payload: count,
  };
};

export const setIsSubmitClicked = isClicked => {
  return {
    type: types.SET_IS_SUBMIT_CLICKED,
    payload: isClicked,
  };
};

export const setCurrentSection = section => {
  return {
    type: types.SET_CURRENT_SECTION,
    payload: section,
  };
};

export const removeCurrentSection = () => {
  return {
    type: types.REMOVE_CURRENT_SECTION,
  };
};

export const showCorrectAnswer = () => {
  return {
    type: types.SHOW_CORRECT_ANSWER,
  };
};

export const storeAutoSelected = (
  selectedAfterSectionId,
  autoSelectedQuestionId,
) => {
  return {
    type: types.STORE_AUTO_SELECTED,
    payload: { selectedAfterSectionId, autoSelectedQuestionId },
  };
};
